import script from "./TestimonialsCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./TestimonialsCarousel.vue?vue&type=script&setup=true&lang=js"

import "./TestimonialsCarousel.vue?vue&type=style&index=0&id=042a1f8a&scoped=true&lang=css"
import "./TestimonialsCarousel.vue?vue&type=style&index=1&id=042a1f8a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-042a1f8a"]])

export default __exports__